import { render, staticRenderFns } from "./swHome.vue?vue&type=template&id=cb362efa&scoped=true&"
import script from "./swHome.vue?vue&type=script&lang=js&"
export * from "./swHome.vue?vue&type=script&lang=js&"
import style0 from "./swHome.vue?vue&type=style&index=0&id=cb362efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb362efa",
  null
  
)

export default component.exports